import {
  AnnotationType,
  BRUSH_ANNOTATION_TYPE,
  POLYLINE_ANNOTATION_TYPE,
  TAG_ANNOTATION_TYPE,
} from '../../types/annotation'

type Label = {
  name: string
  color: string
}

/**
 * Create a Label Studio compatible XML configuration given the annotation type
 * and the labels.
 */
export const makeConfigFor = (annotationType?: AnnotationType) => (
  labels: Label[]
) => {
  if (!annotationType) return makeConfigForView(labels)

  const makeConfig = {
    [TAG_ANNOTATION_TYPE]: makeConfigForTag,
    [BRUSH_ANNOTATION_TYPE]: makeConfigForBrush,
    [POLYLINE_ANNOTATION_TYPE]: makeConfigForPolyline,
  }[annotationType]

  return makeConfig(labels)
}

const makeConfigForTag = (labels: Label[]) => `
  <View>
    ${getImageXml()}
    <Choices name="choice" toName="image">
      ${getLabelsXml(labels, choiceXmlFormatter)}
    </Choices>
  </View>
`

const makeConfigForBrush = (labels: Label[]) => `
  <View>
    ${getImageXml()}
    <BrushLabels name="tag" toName="image">
      ${getLabelsXml(labels, labelXmlFormatter)}
    </BrushLabels>
  </View>
`

const makeConfigForPolyline = (labels: Label[]) => `
  <View>
    ${getImageXml()}
    <RectangleLabels name="label" toName="image">
      ${getLabelsXml(labels, labelXmlFormatter)}
    </RectangleLabels>
  </View>
`

const makeConfigForView = (_: Label[]) => `
  <View>
    ${getImageXml()}
  </View>
`

const choiceXmlFormatter = (label: Label) => `<Choice value="${label.name}"/>`

const labelXmlFormatter = (label: Label) =>
  `<Label value="${label.name}" background="${label.color}"/>`

const getImageXml = () =>
  `<Image name="image" value="$image" zoom="true" zoomControl="true" rotateControl="false"/>`

const getLabelsXml = (labels: Label[], formatter: (label: Label) => string) =>
  labels.map(formatter).join('')
